import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggingOut: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsLoggingOut: (state, action) => {
      state.isLoggingOut = action.payload;
    },
  },
});

export const { setIsLoggingOut } = authSlice.actions;
export default authSlice.reducer;
